import React from "react";
import { Typography, Card, CardContent } from "@mui/material";
import { EARNINGS } from "../PaymentSetup.constants";
import { StatsRow, StatBlock, StatLabel, StatValue } from "../PaymentSetup.styles";

const EarningsSummaryCard = ({ totals }) => {
  if (!totals) return null;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {EARNINGS.TITLE}
        </Typography>
        <StatsRow>
          <StatBlock>
            <StatLabel variant="body2">{EARNINGS.TOTAL_EARNINGS}</StatLabel>
            <StatValue variant="h5">${totals.earnings.toFixed(2)}</StatValue>
          </StatBlock>
          <StatBlock>
            <StatLabel variant="body2">{EARNINGS.GROSS_REVENUE}</StatLabel>
            <Typography variant="h5" color="text.secondary">
              ${totals.grossRevenue.toFixed(2)}
            </Typography>
          </StatBlock>
          <StatBlock>
            <StatLabel variant="body2">{EARNINGS.TOTAL_SESSIONS_PAID}</StatLabel>
            <Typography variant="h5" color="text.secondary">
              {totals.transferCount}
            </Typography>
          </StatBlock>
        </StatsRow>
      </CardContent>
    </Card>
  );
};

export default EarningsSummaryCard;
